import { useTranslation } from '@jq4race/i18n';
import { BadgeCheck } from 'lucide-react';

// frequent-customer-memberships · Slice S4 (design §7, Capability 7) —
// advisory-only banner shown when the plate lookup (useMembershipLookup)
// matches a COVERED membership (active or past_due/in-grace). Mirrors the
// inline alert styling already used by CheckinPage's offline/top-error
// banners (role="alert" + colored border/background), rather than
// DuplicatePlateDialog's blocking <Dialog> — this banner is informational
// and must NEVER block or gate the check-in flow. The server-authoritative
// decision is enforced independently inside CreateTicketUseCase.

interface MemberBannerProps {
  memberName: string | null;
}

export function MemberBanner({ memberName }: MemberBannerProps) {
  const { t } = useTranslation('checkin');

  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-sm border border-emerald-600/60 bg-emerald-600/10 px-3 py-3 text-[13px] text-foreground"
    >
      <BadgeCheck className="size-4 shrink-0 text-emerald-600" strokeWidth={1.5} />
      <span>
        <span className="font-semibold">{t('memberBanner.label')}</span>{' '}
        {memberName
          ? t('memberBanner.withName', { name: memberName })
          : t('memberBanner.withoutName')}
      </span>
    </div>
  );
}
